import { FeatureConfiguration } from "..";
import { historyMiddleware } from "./middleware/historyMiddleware";

export default function (config: FeatureConfiguration) {
    config.middleware.push(historyMiddleware(config.history));
}
